import { __awaiter } from "tslib";
import moment from 'moment';
import { alas, status } from '@/alas';
import { showError, showSuccess } from '@/store';
import { defineComponent, reactive, ref, computed, onMounted, onUnmounted } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let t = m => context.root.$t(m);
        let route = context.root.$route;
        let router = context.root.$router;
        // ================
        //
        // refs
        //
        let farm = ref(status.fetch('farm'));
        let cycle = ref(status.fetch('cycle'));
        let picture = ref(status.fetch('picture'));
        let config = ref(status.fetch('config'));
        let calendarDay = ref(alas.make('farm', 'calendarDay'));
        // ================
        //
        // state
        //
        let $ = reactive({
            canEdit: true,
            editInt: null,
            validate: false
        });
        // ================
        //
        // computed
        //
        let isLive = computed(() => cycle.value.finishedAt == null);
        // ================
        //
        // mounted
        //
        onMounted(() => {
            if (isLive.value) {
                picture.value.$o.fetchToday.seek({
                    farmId: farm.value.id
                });
            }
            calendarDay.value.$o.fetch.start({
                farmId: farm.value.id,
                date: moment().format('YYYY-MM-DD')
            });
            refreshCanEdit();
            $.editInt = setInterval(() => {
                refreshCanEdit();
                if ($.canEdit === false) {
                    clearInterval($.editInt);
                }
            }, 2000);
        });
        onUnmounted(() => {
            if ($.editInt) {
                clearInterval($.editInt);
            }
        });
        // ================
        //
        // methods
        //
        let refreshCanEdit = () => {
            $.canEdit = !moment().format('HH:mm').match('23:5');
        };
        let toTop = () => {
            window.scrollTo(0, 0);
        };
        let updatePicture = () => __awaiter(this, void 0, void 0, function* () {
            let validate = picture.value.$validate();
            if (validate.success === false) {
                return showError(t('驗證錯誤'));
            }
            try {
                yield picture.value.$o.update.start();
                showSuccess(t('更新成功'));
            }
            catch (error) {
                showError(error);
            }
        });
        let createTodayPicture = () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield picture.value.$o.createToday.start({
                    type: cycle.value.type,
                    breed: cycle.value.breed,
                    farmId: farm.value.id
                });
                yield picture.value.$o.fetchToday.start({
                    farmId: farm.value.id
                });
            }
            catch (error) {
                showError(error);
            }
        });
        // ================
        //
        // done
        //
        return {
            $,
            farm,
            cycle,
            picture,
            config,
            calendarDay,
            isLive,
            refreshCanEdit,
            toTop,
            updatePicture,
            createTodayPicture
        };
    }
});
